import Base from "./base";

class Main extends Base {
  login = (data) => this.postRequest("/auth/admin/login", data);
  logOff = () => this.getRequest("/auth/logoff");
  getuser = () => this.getRequest("/auth/getUser");
  getUserDetails = (data) => this.getRequest(`/admin/users/details/${data}`);
  getUserBranches = (id, date) =>
    this.getRequest(`/admin/branches/list/${id}`, date);
  setUserBranchAction = ({ id, data }) =>
    this.postRequest(`/admin/branches/change-branch-status/${id}`, data);
  updateUserBranchSubscription = ({ id, data }) => 
    this.postRequest(`/admin/branches/change-branch-subscription/${id}`, data);
  activateUser = (data) => this.postRequest("/admin/users/activate", data);
  deActivateUser = (data) => this.postRequest("/admin/users/reject", data);
  deleteUser = (data) => this.deleteRequest("/admin/users/delete", data);
  updateBranchCount = (data) =>
    this.putRequest("/admin/users/update-branch-count", data);
  updatePromoCode = (data) =>
    this.putRequest("/admin/users/discount-promo", data);
  updateDealerCode = (data) =>
    this.putRequest("/admin/users/dealer-code", data);
  updateAmbassadorCode = (data) =>
    this.putRequest("/admin/users/ambassador-code", data);
  updateTransferInvoiceNumber = (data) =>
    this.putRequest("/admin/users/transfer-invoice-number", data);
  updateBillingExpirationDate = (data) =>
    this.putRequest("/admin/users/billing-expiration-date", data);
  updateBillingEmailAdminInclusion = (data) =>
    this.putRequest("/admin/users/billing-email-admin-inclusion", data);
  updatePassword = (data) => this.putRequest("/auth/change-password", data);
  refreshToken = () => this.getRequest("/auth/refresh");
  setUserStatus = (data) =>
    this.postRequest("/admin/users/change-status", data);
  setBranchStatus = (data) =>
    this.postRequest("/admin/branches/change-status", data);
  setGoodStatus = (data) =>
    this.postRequest("/v2/admin/good-request/change-status", data);
  uploadFile = (file, path) =>
    this.postRequest(`/admin/files/write`, file, { name: file.name, path });
  uploadFiles = (formData) => this.postRequest(`/files/upload`, formData);
  changeEmail = ({ id, data }) =>
    this.putRequest(`/v2/admin/users/change-email/${id}`, data);
  updateAdvertisement = (data, id) =>
    this.putRequest(`/v2/admin/advertisement/${id}`, data);
  deleteAdvertisementImage = (data, id) =>
    this.postRequest(`/v2/admin/advertisement/${id}/delete-images`, data);
  copyAdvertisement = (id) =>
    this.postRequest(`/v2/admin/advertisement/${id}/copy`);
  acceptGoodChange = (id, data) =>
    this.postRequest(`/v2/admin/goods-changes/${id}/accept`, data);
  rejectGoodChange = (id, data) =>
    this.postRequest(`/v2/admin/goods-changes/${id}/decline`, data);
  getBranchesUnseenCount = () =>
    this.getRequest("/admin/branches/unseen-count");
  getGoodRequestsUnseenCount = () =>
    this.getRequest("/v2/admin/good-request/unseen-count");
  updateGoodRequestsUnseenCount = (data) =>
    this.putRequest("/v2/admin/good-request/seen", data);
  getMessagesUnseenCount = () =>
    this.getRequest("/web/v2/home/contact/unseen-count");
  updateMessagesUnseenCount = (data) =>
    this.putRequest("/web/v2/home/contact/seen", data);
  getUsersUnseenCount = () => this.getRequest("/admin/users/unseen-count");
  updateUsersUnseenCount = (data) => this.putRequest("/admin/users/seen", data);
  getPlans = () => this.getRequest("/v2/admin/plans");
  getFeatures = () => this.getRequest("/v2/admin/features");
  addFeature = (data) => this.postRequest(`/v2/admin/features`, data);
  updateFeature = (id, data) => this.putRequest(`/v2/admin/features/${id}`, data);
  deleteFeature = (id) => this.deleteRequest(`/v2/admin/features/${id}`);
  getPlanDetails = (id) => this.getRequest(`/v2/admin/plans/${id}`);
  createChildPlan = (parentId, data) =>
    this.postRequest(`/v2/admin/plans/${parentId}/child`, data);
  updateUserDefaultPlan = (data) => this.putRequest("/admin/users/update-user-default-plan", data);
  updatePlan = (id, data) => this.putRequest(`/v2/admin/plans/${id}`, data);
  updatePlanStatus = (id, data) => this.putRequest(`/v2/admin/plans/${id}/status`, data);
  updatePlanPrice = (planId, planPriceId, data) => this.putRequest(`/v2/admin/plans/${planId}/prices/${planPriceId}`, data);
  deletePlanFeature = (planId, featureId) => this.deleteRequest(`/v2/admin/plans/${planId}/features/${featureId}`);
  updatePlanFeatureIncludes = (planId, featureId) => this.putRequest(`/v2/admin/plans/${planId}/features/${featureId}/includes`);
  addFeatureForPlan = (planId, data) => this.postRequest(`/v2/admin/plans/${planId}/features`, data);
  reorderPlanFeatures = (planId, featureIds) =>
    this.putRequest(`/v2/admin/plans/${planId}/features/order`, {
      feature_ids: featureIds,
    });
  getSecuritySettings = () => this.getRequest(`/auth/admin/2fa/settings`);
  generate2FASecret = (data) => this.postRequest(`/auth/admin/2fa/generate`, data);
  verify2FA = (data) => this.postRequest("/auth/admin/2fa/verify", data);
  disable2FA = (data) => this.postRequest(`/auth/admin/2fa/disable`, data);
  deleteV2sliderItems = (id) => this.deleteRequest(`/web/v2/home/slider/items/${id}`);
}

export default new Main();
